/* import { useLocation } from "react-router-dom"; */
// @mui
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  AppBar,
  Toolbar,
  Container,
  IconButton,
  Tooltip,
  Button,
  Stack,
  Typography,
} from "@mui/material";
// hooks
import useOffSetTop from "../../hooks/useOffSetTop";
/* import useResponsive from "../../hooks/useResponsive"; */
// utils
import cssStyles from "../../utils/cssStyles";
// config
import { HEADER } from "../../config";
// components
import Logo from "../../components/Logo";
//
import MenuDesktop from "./MenuDesktop";
import MenuMobile from "./MenuMobile";

import navConfig from "./MenuConfig";
import { MotionContainer, varFade } from "../../components/animate";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";
import useResponsive from "src/hooks/useResponsive";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setType } from "src/features/scrollSlice";
import PhoneIcon from "@mui/icons-material/Phone";

// ----------------------------------------------------------------------

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: HEADER.MOBILE_HEIGHT,
  transition: theme.transitions.create(["height", "background-color"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up("md")]: {
    height: HEADER.MAIN_DESKTOP_HEIGHT,
  },
}));

const ToolbarShadowStyle = styled("div")(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: "auto",
  borderRadius: "50%",
  position: "absolute",
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

// ----------------------------------------------------------------------

export default function MainHeader() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { t } = useTranslation();

  const isXtraLarge = useResponsive("only", "xl");

  const isOffset = useOffSetTop(HEADER.MAIN_DESKTOP_HEIGHT);

  const theme = useTheme();

  const { pathname } = useLocation();

  const isDesktop = useResponsive("up", "md");

  const isHome = pathname === "/";

  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: "transparent" }}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            ...cssStyles(theme).bgBlur(),
            height: { md: HEADER.MAIN_DESKTOP_HEIGHT - 16 },
          }),
        }}
      >
        <Container
          maxWidth={isXtraLarge ? "xl" : "lg"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack spacing={1} direction={"row"} alignItems={"flex-end"}>
            <MotionContainer variants={varFade().inLeft}>
              <Logo />
            </MotionContainer>
            {(isDesktop && isOffset) || !isHome ? (
              <MotionContainer variants={varFade().inUp}>
                <Typography
                  color={"primary"}
                  variant="h4"
                  style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
                >
                  Aarmando Group
                </Typography>
              </MotionContainer>
            ) : (
              <></>
            )}
          </Stack>

          {/*   <Label color="info" sx={{ ml: 1 }}>
            v3.0.0
          </Label> */}
          <Box sx={{ flexGrow: 1 }} />

          {/*     {isDesktop && (
            <MenuDesktop
              isOffset={isOffset}
              isHome={isHome}
              navConfig={navConfig}
            />
          )} */}

          {/*  <MotionContainer variants={varFade().inUp}>
            <Button
              size="large"
              onClick={() => {
                dispatch(setType("home"));

                if (!isHome) {
                  navigate("/");
                }
              }}
              style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
            >
              Home
            </Button>
          </MotionContainer> */}

          {/* <MotionContainer variants={varFade().inUp}>
            <Button
              size="large"
              onClick={() => {
                dispatch(setType("services"));

                if (!isHome) {
                  navigate("/");
                }
              }}
              style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
            >
              Services
            </Button>
          </MotionContainer> */}

          {isDesktop ? (
            <MenuDesktop
              isOffset={isOffset}
              isHome={isHome}
              navConfig={navConfig}
            />
          ) : (
            <MenuMobile
              isOffset={isOffset}
              isHome={isHome}
              navConfig={navConfig}
            />
          )}

          {/*         <MotionContainer variants={varFade().inUp}>
            <Button
              size="large"
              onClick={() => {
                navigate("/our-team");
              }}
              style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
            >
              Our Team
            </Button>
          </MotionContainer> */}

          {/*    <MotionContainer variants={varFade().inUp}>
            <Button
              size="large"
              onClick={() => {
                dispatch(setType("whyChoosingUs"));

                if (!isHome) {
                  navigate("/");
                }
              }}
              style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
            >
              About Us
            </Button>
          </MotionContainer> */}
          {/* 
          <MotionContainer variants={varFade().inUp}>
            <Button
              size="large"
              onClick={() => {
                dispatch(setType("quote"));

                if (!isHome) {
                  navigate("/");
                }
              }}
              style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
            >
              Contact Us
            </Button>
          </MotionContainer> */}

          <MotionContainer variants={varFade().inUp}>
            <Tooltip title={"Call us on 2183030"}>
              <IconButton
                size="large"
                target="_blank"
                rel="noopener"
                href="tel:+2302183030"
                color="primary"
              >
                <PhoneIcon
                  fontSize="large"
                  style={{ color: !isOffset && isHome ? "#FFFFFF" : undefined }}
                />
              </IconButton>
            </Tooltip>
          </MotionContainer>
          {/* 
          <MotionContainer variants={varFade().inUp}>
            <LanguagePopover />
          </MotionContainer> */}

          {/*           <Button
            variant="contained"
            target="_blank"
            rel="noopener"
            href="https://material-ui.com/store/items/minimal-dashboard/"
          >
            Purchase Now
          </Button> */}

          {/*      {!isDesktop && (
            <MenuMobile
              isOffset={isOffset}
              isHome={isHome}
              navConfig={navConfig}
            />
          )} */}
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
